import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { collateralApi, ApiError } from '../services/collateralApi';

export default function useVerificationConfigPageEdit() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const passedData = (location.state as any)?.data;
    const [isLoading, setIsLoading] = useState(!passedData);
    const [form, setForm] = useState<any>(passedData || {});
    const [analystSearch, setAnalystSearch] = useState('');
    const [analystResults, setAnalystResults] = useState<any[]>([]);

    useEffect(() => {
        if (passedData || !id) return;
        setIsLoading(true);
        collateralApi.getVerificationConfigView(id)
            .then(setForm)
            .catch((e: any) => {
                if (e instanceof ApiError && e.status === 404) return navigate('/not-found');
                navigate('/error');
            })
            .finally(() => setIsLoading(false));
    }, [id, navigate, passedData]);

    const set = (field: string, value: any) => setForm((prev: any) => ({ ...prev, [field]: value }));
    const ev = (field: string) => (e: any) => set(field, e.target.value);

    const searchAnalyst = async (query: string) => {
        if (query.length < 3) { setAnalystResults([]); return; }
        try {
            const res = await collateralApi.searchPerson(query);
            setAnalystResults(res || []);
        } catch { setAnalystResults([]); }
    };

    const handleSave = async () => {
        try {
            await collateralApi.updateVerificationConfig(id!, {
                analyst_name: analystSearch || form.analystName || null,
                pendency: form.pendency,
                observation: form.observation,
                collateral_saved: form.collateralSaved,
                court_registration: form.courtRegistration,
                contract_to_register: form.contractToRegister,
                debtor_notification_done: form.debtorNotificationDone,
            });
            toast.success('Configuração atualizada!');
            navigate(-1);
        } catch { toast.error('Erro ao salvar'); }
    };

    return {
        id, navigate, isLoading, form, set, ev,
        analystSearch, setAnalystSearch, analystResults, setAnalystResults, searchAnalyst,
        handleSave,
    };
}
